import { query } from '@trlogic/client-js';
import { CaseSettings } from '../../domain/case/CaseDomains';
import NavigationUtil from '../../util/NavigationUtil';
import Filter = query.Filter;
import QueryBuilder = query.QueryBuilder;
import SelectQuery = query.SelectQuery;
import Order = query.Order;

class TransactionPageUtil {
  public static getTransactionQuery(
    currentCaseSettings: CaseSettings | undefined,
    caseSettings: Pick<CaseSettings, 'id' | 'name' | 'dataSource' | 'keyField'>[],
    filter: Filter,
    rows: number,
    currentPage: number,
    sorts: Order[],
  ): SelectQuery {
    if (!currentCaseSettings && caseSettings.length == 0) {
      throw new Error('Alarm domain not found');
    }
    const endpoint = TransactionPageUtil.getEndpoint(currentCaseSettings);
    return QueryBuilder.select()
      .from(endpoint)
      .where(filter)
      .orderBy(...this.getSort(sorts))
      .limit(rows)
      .skip((currentPage - 1) * rows)
      .build();
  }

  public static getEndpoint(selectedCaseSettings: CaseSettings | undefined) {
    if (selectedCaseSettings) {
      return `risk_transaction_log_${NavigationUtil.getTenant()}_${selectedCaseSettings.dataSource}_*`.toLowerCase();
    }
    return `risk_transaction_log_${NavigationUtil.getTenant()}_*`;
  }

  public static getSort(sorts: Order[]): Order[] {
    if (sorts.length == 0) {
      return [
        {
          operator: 'DESC',
          field: 'createdAt',
        },
      ];
    }
    return sorts;
  }
}

export default TransactionPageUtil;
